const base = 'shrink-0';

/** Total referral income — stacked coins */
export function IconReferralIncome({ className = `${base} w-5 h-5 text-hash-gold` }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <ellipse cx="12" cy="16" rx="7" ry="3" />
      <path d="M5 13c0-1.7 3.1-3 7-3s7 1.3 7 3" />
      <ellipse cx="12" cy="10" rx="6" ry="2.5" />
      <path d="M6 7.5c0-1.4 2.7-2.5 6-2.5s6 1.1 6 2.5" />
    </svg>
  );
}

/** Today’s income — calendar */
export function IconReferralToday({ className = `${base} w-5 h-5 text-emerald-400` }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M4 9h16M8 3v4M16 3v4" />
      <rect x="9" y="12" width="2" height="2" rx="0.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Direct referrals — two people */
export function IconReferralDirect({ className = `${base} w-5 h-5 text-hash-gold` }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <circle cx="9" cy="8" r="2.5" />
      <path d="M5 18v-1c0-1.7 1.8-3 4-3s4 1.3 4 3v1" />
      <circle cx="16" cy="9" r="2" />
      <path d="M13 18v-0.8c0-1.2 1.2-2.2 3-2.2" />
    </svg>
  );
}

/** Upline — simple tree (upline above two) */
export function IconReferralUpline({ className = `${base} w-5 h-5 text-hash-gold` }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <circle cx="12" cy="6" r="2" />
      <path d="M12 8v4M12 12L7 18M12 12l5 6" strokeLinecap="round" />
      <circle cx="7" cy="18.5" r="2" />
      <circle cx="17" cy="18.5" r="2" />
    </svg>
  );
}

/** Copy */
export function IconReferralCopy({ className = `${base} w-4 h-4 text-hash-gold` }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
      <rect x="8" y="8" width="11" height="11" rx="1.5" />
      <path d="M6 16H5a2 2 0 01-2-2V5a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  );
}

/** 10-level plan progress — stacked tier mark (simple logo) */
export function IconTenLevelPlanProgress({
  className = `${base} h-8 w-8 text-hash-gold`,
  title = '10 level plan',
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinejoin="round"
      role="img"
      aria-label={title}
    >
      <rect x="2" y="17.5" width="20" height="4" rx="1" />
      <rect x="4.5" y="12.5" width="15" height="4" rx="1" />
      <rect x="7" y="7.5" width="10" height="4" rx="1" />
      <rect x="9.5" y="2.5" width="5" height="4" rx="0.75" />
    </svg>
  );
}
